import React, {ReactElement} from "react";
import SharedChat from "../../Components/SharedChat";

export default function SharedChatPage():ReactElement {
  return (
    <>
      <SharedChat />
    </>
  );
}